uniform sampler2D diffuse;
uniform vec2 uTextureSize;
uniform vec2 uQuadSize;
uniform float uOpacity;

varying vec2 vUv;

vec2 getUV(vec2 uv, vec2 textureSize, vec2 quadSize) {
    vec2 tempUV = uv - vec2(0.5);

    float quadAspect = quadSize.x / quadSize.y;
    float textureAspect = textureSize.x / textureSize.y;

    if (quadAspect < textureAspect) {
        tempUV *= vec2(quadAspect / textureAspect, 1.0);
    } else {
        tempUV *= vec2(1.0, quadAspect / textureAspect);
    }

    tempUV += vec2(0.5);
    return tempUV;
}

void main() {
    vec2 correctUv = getUV(vUv, uTextureSize, uQuadSize);
    vec4 diffuseSample = texture2D(diffuse, correctUv);
    gl_FragColor = vec4(diffuseSample.rgb, diffuseSample.a * uOpacity);
}
